<template>
  <el-row>
    <el-form :model="distributionBusinessMaintenanceEmployeeForm"
             ref="distributionBusinessMaintenanceEmployeeRef"
             :rules="rules"
             @onSelectInfo="onSelectInfo"
             addAction=""
             editAction="/businessIntranet/distributionBusinessMaintenanceEmployee.action"
             selectAction="/businessIntranet/selectBusinessMaintenanceEmployee.action"
             label-width="150px"
             style="width:50%"
             v-form>

        <el-form-item label="维护人：">
          <employee-select  ref="employee-select" v-model="distributionBusinessMaintenanceEmployeeForm.maintenanceEmployeeSnapId" @clear="clear" @onEmployeeSelected="onEmployeeSelectedQuery"
                           placeholder="请选择维护人"></employee-select>
        </el-form-item>
        <el-form-item label="下次跟进时间：" prop="endTime">
            <el-date-picker
                    v-model="distributionBusinessMaintenanceEmployeeForm.nextVisitTime"
                    type="date"
                    value-format="timestamp"
                    placeholder="选择日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item>
        <el-button type="primary">确定</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import EmployeeSelect from '@/components/EmployeeSelect'

export default {
  name: 'distributionBusinessMaintenanceEmployee',
  extends: BasicPager,
  components: { EmployeeSelect },
  data: function () {
    return {
      rules: {},
      distributionBusinessMaintenanceEmployeeForm: {
        id: null,
        maintenanceEmployeeSnapId: null,
        maintenanceName: null,
        nextVisitTime: null
      }
    }
  },
  created () {
    this.distributionBusinessMaintenanceEmployeeForm.id = this.$route.query.businessId
  },
  methods: {
    clear: function () {
      this.distributionBusinessMaintenanceEmployeeForm.maintenanceEmployeeSnapId = null
      this.distributionBusinessMaintenanceEmployeeForm.maintenanceName = null
      this.distributionBusinessMaintenanceEmployeeForm.nextVisitTime = null
    },
    onEmployeeSelectedQuery: function (item) {
      this.distributionBusinessMaintenanceEmployeeForm.maintenanceEmployeeSnapId = item.snapshotId
      this.distributionBusinessMaintenanceEmployeeForm.maintenanceName = item.text
    },
    onFilterParams: function (params) {

    },
    onSelectInfo: function (dataInfo) {
      let employeeSelect = this.$refs['employee-select']
      if (dataInfo && dataInfo.datas) {
        employeeSelect.setValue(dataInfo.datas.maintenanceEmployeeId)
      }
    }
  },
  filters: {}

}
</script>

<style scoped>

</style>
